import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import s from './basketIssues.scss';
import Label from '../Label';
import { basketIssues } from '../../defineMessages';

const BasketIssues = ({ issues }) => {
  const filteredIssues = [];
  const foundIssueTypes = {};

  // If server responds multiple issues with same type, use only one.
  issues.forEach(issue => {
    const { type } = issue;

    if (!foundIssueTypes[type] && basketIssues[type]) {
      foundIssueTypes[type] = true;
      filteredIssues.push(issue);
    }
  });

  if (!filteredIssues.length) return null;

  return (
    <div className={s.basketIssues}>
      <Label tag="div" className="basket-issues--header" size="heading" bold>
        <FormattedMessage {...basketIssues.header} />
      </Label>
      {filteredIssues.map(({ type }) => (
        <Label tag="div" className="basket-issue" size="subheading" key={type}>
          - <FormattedMessage {...basketIssues[type]} />
        </Label>
      ))}
    </div>
  );
};

BasketIssues.propTypes = {
  issues: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default withStyles(s)(BasketIssues);
